import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';

export type RemovePlanSetFormProps = {
  id: string;
  handleClose: () => void;
};

export const FC = (props: RemovePlanSetFormProps) => {
  const [
    fnRemovePlanSetForm,
    { loading }
  ] = ds.useRemovePlanSet();
  const form = ds.useFormState(props.id);
  const handleSubmit = async (id: string) => {

    await fnRemovePlanSetForm(id);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      isLoading={loading}
      handleSubmit={async () => {
        await handleSubmit(props.id);
        props.handleClose();
      }}
      cancelButtonText='Cancel'
      successButtonText='Remove'
    >
      <></>
    </FormBaseLayout.FC>

  );
};
